// WorldCard.js — Individual world building card for NeevVerse city map
import React from 'react';
import { motion } from 'framer-motion';

export default function WorldCard({ world, index, onEnter }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.92 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: index * 0.04, type: 'spring', stiffness: 260, damping: 22 }}
      whileTap={{ scale: 0.93 }}
      whileHover={{ scale: 1.04, y: -3 }}
      onClick={() => onEnter(world.id)}
      style={{
        background: `linear-gradient(145deg, ${world.color} 0%, ${world.color}CC 100%)`,
        borderRadius: 16,
        padding: '16px 10px 12px',
        cursor: 'pointer',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden',
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'space-between',
        boxShadow: `0 6px 20px ${world.color}55`,
        border: 'none',
      }}
    >
      {/* Shine overlay */}
      <div style={{
        position: 'absolute', top: 0, left: 0, right: 0, height: '50%',
        background: 'linear-gradient(180deg, rgba(255,255,255,0.18) 0%, transparent 100%)',
        borderRadius: '16px 16px 0 0',
        pointerEvents: 'none',
      }} />

      {/* Emoji icon */}
      <div style={{ fontSize: 38, lineHeight: 1, marginBottom: 6, filter: 'drop-shadow(0 2px 4px rgba(0,0,0,0.3))' }}>
        {world.icon}
      </div>

      {/* World name */}
      <p style={{
        margin: 0,
        fontSize: 11,
        fontWeight: 900,
        color: 'white',
        lineHeight: 1.3,
        fontFamily: "'Nunito', sans-serif",
        textShadow: '0 1px 6px rgba(0,0,0,0.4)',
        flex: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 2px',
      }}>
        {world.name}
      </p>

      {/* Enter button */}
      <div style={{
        marginTop: 8,
        background: 'rgba(255,255,255,0.9)',
        borderRadius: 10,
        padding: '4px 14px',
        fontSize: 10,
        fontWeight: 900,
        color: world.color,
        fontFamily: "'Nunito', sans-serif",
        letterSpacing: '0.04em',
        boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
      }}>
        ENTER →
      </div>
    </motion.div>
  );
}
